// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--1vdtE","hero__textbox":"hero-module--hero__textbox--T6mZ3","hero__img":"hero-module--hero__img--1AURc"};